import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTERS,
  FETCH_NOTIFICATIONS_SUCCESS,
  ADD_NOTIFICATION_SUCCESS,
  EDIT_NOTIFICATION_SUCCESS,
  SET_SELECTED,
  DELETE_NOTIFICATION_SUCCESS
} from "./notificationsSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  notifications: [],
  primaryButtonDisabled: true,
  selected: {
    notificationId: null,
    all_organizations: false,
    published: false,
    organization_ids: [],
    message: "",
    title: ""
  }
};

function sortById(a, b) {
  return a.id > b.id ? 1 : -1;
}

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      areChartsLoading: action.payload
    }),

    [RESET_FILTERS]: (state) => {
      return {
        ...state,
        filtersDirty: false,
        primaryButtonDisabled: true,
        selected: {
          ...initialState.selected
        }
      };
    },
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_SELECTED]: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        ...action.payload
      }
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => {
      return {
        ...state,
        currentUser: action.payload
      };
    },
    [FETCH_NOTIFICATIONS_SUCCESS]: (state, action) => {
      return {
        ...state,
        notifications: action.payload.sort(sortById)
      };
    },
    [ADD_NOTIFICATION_SUCCESS]: (state, action) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload]
      };
    },
    [EDIT_NOTIFICATION_SUCCESS]: (state, action) => {
      let notifications = state.notifications.map((notification) => {
        if (notification.id === action.payload.id) {
          return action.payload.notification;
        }
        return notification;
      });

      return {
        ...state,
        notifications
      };
    },
    [DELETE_NOTIFICATION_SUCCESS]: (state, action) => {
      let notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );

      return {
        ...state,
        notifications
      };
    }
  },

  initialState
);
